<template>
  <div class="col-md-13 mt-md-3 text-right">
    <div @click="selectAccount" class="my-account link">
      <font-awesome-icon class="font-awesome-icon" icon="user-circle"/>
      {{ userName }}
    </div>
  </div>
</template>

<script>
  export default {
    computed: {
      userName() {
        return !this.$store.getters.user ? '' : this.$store.getters.user.name
      }
    },
    methods: {
      selectAccount() {
        this.$router.push({ name: 'account' })
      }
    }
  }
</script>

<style lang="scss" scoped>
</style>
